import { Action } from "../../../../processes/models/Action/Action";
import ActionHistory from "../../../../processes/models/ActionHistory/ActionHistory";
import { stateT } from "../../types";
import { getUIState } from "../uiSelectors";

export const getDataHistory = (state: stateT) => {
  const { dataHistory } = state.ui;
  return dataHistory;
};

export const getActionHistory = (state: stateT) => {
  const dataHistory = getDataHistory(state);
  const actionHistory = new ActionHistory();
  if (dataHistory) {
    actionHistory.deserialize(dataHistory);
  } else {
    const stateUI = getUIState(state);
    actionHistory.push(
      Action.fromJSON({
        before: stateUI,
        after: stateUI,
      })
    );
  }

  return actionHistory;
};

export const hasUndo = (state: stateT) => {
  const dataHistory = getDataHistory(state);
  if (!dataHistory) return false;
  const actionHistory = new ActionHistory();
  actionHistory.deserialize(dataHistory);
  return actionHistory.hasUndo();
};

export const hasRedo = (state: stateT) => {
  const dataHistory = getDataHistory(state);
  if (!dataHistory) return false;
  const actionHistory = new ActionHistory();
  actionHistory.deserialize(dataHistory);
  return actionHistory.hasRedo();
};
